export default __webpack_public_path__ + "static/voyage-08af24d9c2e27728fb9927a7338665ce.jpg";